import { FC, ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import useCompany from 'src/hooks/useCompany';

interface Props {
  display: ReactElement;
}

const SelectACompanyPlaceholder: FC<Props> = ({ display }) => {
  const { company: selectedCompany } = useCompany();
  const { t } = useTranslation();
  if (selectedCompany?.companyId) {
    return display;
  }

  return <p className="text-center text-sm font-bold mt-6">{t('Please Select a Company')}</p>;
};

export default SelectACompanyPlaceholder;
